import { Space } from 'antd';
import { PermissionContext } from 'components/Global/AuthLayout';
import Buttons from 'components/Global/Buttons';
import { useContext } from 'react';
import styles from './index.module.scss';

type Props = {
	button: any;
	isAdd: boolean;
};

const ShiftMasterHeader = (props: Props) => {
	const { isAdd, button } = props;
	const permissions = useContext(PermissionContext);

	const isAddPermission = permissions.allowedPermissions.includes('Add_Shift_Master');
	return (
		<div className={styles['employee-header']}>
			<div></div>
			{(isAdd && isAddPermission) && (
				<Space>
					<Buttons buttons={button} />
				</Space>
			)}
		</div>
	);
};

export default ShiftMasterHeader;
